import cn from 'classnames';
import styles from './userDropdown.module.scss';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import type { Account } from '../../../redux/types.ts';
import { ListChecksIcon } from '@phosphor-icons/react/dist/csr/ListChecks';
import { PushPinSimpleIcon } from '@phosphor-icons/react/dist/csr/PushPinSimple';
import { UserCirclePlusIcon } from '@phosphor-icons/react/dist/csr/UserCirclePlus';

type UserItemsProps = {
  onRedirectToCreateAccount: () => void;
  onRedirectToSelectAccount: () => void;
  onChangeAccount: (account: Account) => void;
  pinnedAccounts: Account[];
};

const { userMenuDivider, userMenuItem, userMenuActive, iconPinnedAccount, iconAccount } = styles;

const UserItems: FC<UserItemsProps> = ({
  onRedirectToCreateAccount,
  onRedirectToSelectAccount,
  onChangeAccount,
  pinnedAccounts,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'userDropdown' });
  const { pathname } = window.location;

  return (
    <>
      <div className={userMenuDivider}></div>
      <div
        className={cn(userMenuItem, { [userMenuActive]: pathname === '/create-account' })}
        onClick={onRedirectToCreateAccount}
      >
        <UserCirclePlusIcon size={24} className={iconAccount} />
        {t('createAccount')}
      </div>
      <div
        className={cn(userMenuItem, { [userMenuActive]: pathname === '/select-account' })}
        onClick={onRedirectToSelectAccount}
      >
        <ListChecksIcon size={24} className={iconAccount} />
        {t('selectAccount')}
      </div>
      {pinnedAccounts.map(account => (
        <div className={userMenuItem} key={account.accountId} onClick={() => onChangeAccount(account)}>
          <PushPinSimpleIcon size={24} weight="fill" className={iconPinnedAccount} />
          {`${account.accountId} - ${account.name}`}
        </div>
      ))}
    </>
  );
};

export default UserItems;
